import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

export const rows = {
  title: {
    label: "Property Disposition",
    isTitle: true
  },
  projectedExitDate: {
    label: "Projected Exit Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "projectedExitDate",
        variant: "filled",
        decimals: 2,
        monthStyle: { minWidth: "176px" },
        dayStyle: { width: "80px", marginLeft: "16px" },
        yearStyle: { width: "80px", marginLeft: "16px" }
      }
    ]
  },
  actualExitDate: {
    label: "Actual Exit Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "actualExitDate",
        variant: "filled",
        decimals: 2,
        monthStyle: { minWidth: "176px" },
        dayStyle: { width: "80px", marginLeft: "16px" },
        yearStyle: { width: "80px", marginLeft: "16px" }
      }
    ]
  },
  salesPrice: {
    label: "Sales Price",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "salesPrice",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  pricePerUnit: {
    label: "Price Per Unit",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "pricePerUnit",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  pricePerSquareFoot: {
    label: "Price Per SF",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "pricePerSquareFoot",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  exitCapRate: {
    label: "Exit Cap Rate",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "exitCapRate",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  exitDebtYield: {
    label: "Exit Debt Yield",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "exitDebtYield",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  cashOnCash: {
    label: "Cash on Cash Returns",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "cashOnCash",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  internalRateOfReturn: {
    label: "Internal Rate of Return",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "internalRateOfReturn",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  equityMultiple: {
    label: "Equity Multiple",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "equityMultiple",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  salesBrokerCompany: {
    label: "Sales Broker Company",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "salesBrokerCompany",
        name: "salesBrokerCompanyId",
        variant: "filled",
        parentId: "salesBrokerCompany",
        displayWith: option => option.name,
        setValueWith: option => option.id
      }
    ]
  },
  salesBrokerContact: {
    label: "Sales Broker Contact",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "salesBrokerContact",
        name: "salesBrokerContactId",
        variant: "filled",
        parentId: "salesBrokerContact",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: (id, value) => {
          console.log("onChange", { id });
        }
      }
    ]
  },
  notesOnBuyer: {
    label: "Notes on Buyer",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "notesOnBuyer",
        variant: "filled",
        style: { width: "100%" } }
    ]
  }
};
